import React from 'react';

const Footer = () => {
  return (
        
        <div className="row mt-3 pt-3 border-top border-secondary border-opacity-25">
          <div className="col-12 text-center">
            <p className="text-muted small mb-0">
              Aspiring Computer Science Student • Software Development • AI & Emerging Technologies
            </p>
          </div>
        </div>
  );
};

export default Footer;
